import * as React from 'react';
import Typography from '@mui/material/Typography';
import { Container, Button, Box, IconButton, Grid, Select, MenuItem, Alert, Snackbar } from '@mui/material';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import { fetchTechnicalRepairReplacements, updateTechnicalRepairReplacement, emailTechnicalRepairReplacementPdf, fetchCustomers, fetchVehicles, fetchSolutions, fetchUsers } from "../services/ApiService";
import EditIcon from '@mui/icons-material/Edit';
import SendIcon from '@mui/icons-material/Send';
import CircularProgress from '@mui/material/CircularProgress';
import DataTable from '../components/DataTable';
import { z } from "zod";
import { FormModal, RHFTextField, RHFSelect } from "../components/form";

const formatDatetimeLocal = (iso) => {
  if (!iso) return "";
  const dt = new Date(iso);
  return new Date(dt.getTime() - dt.getTimezoneOffset() * 60000)
    .toISOString()
    .slice(0, 16);
};

export function TechnicalRepairReplacement() {
    const [snackbar, setSnackbar] = React.useState({ open: false, message: '', severity: 'success' }); // Snackbar state
    const [sendingEmailId, setSendingEmailId] = React.useState(null);

    const showSnackbar = (message, severity) => {
        setSnackbar({ open: true, message, severity });
    };

    const handleSnackbarClose = () => {
        setSnackbar({ ...snackbar, open: false });
    };
    const [selectedRow, setSelectedRow] = React.useState(null);
    const [editModalOn, setEditModalOn] = React.useState(false);
    const handleEditOff = () => setEditModalOn(false)
    const handleEditOn = (row) => {
        setEditModalOn(true)
        setSelectedRow(row)
    }
    React.useEffect(() => {
        fetchHauliers();
        fetchTruck();
        fetchDeliveries();
        fetchDevices();
        loadUsers()
    }, []);
    const [haulierOptions, setHaulierOptions] = React.useState([]);
    const [truckOptions, setTruckOptions] = React.useState([]);
    const [devicesOptions, setDevicesOptions] = React.useState([]);
    const [usersOptions, setUsersOptions] = React.useState([]);

    const [users, setUsers] = React.useState([]);

    const loadUsers = async () => {
        try {
            const response = await fetchUsers();
            console.log(response);

            const deviceDict = response.data.reduce((acc, item) => {
                acc[item.id] = item.name;
                return acc;
            }, {});
            console.log(response.data);
            console.log(deviceDict);

            setUsersOptions(deviceDict)
            setUsers(response.data);
            console.log(users);

        } catch (error) {
            console.error("Failed to fetch users", error);
        }
    };
    const fetchDeliveries = async () => {
        try {
            const response = await fetchTechnicalRepairReplacements();
            console.log(response.data);

            setEmployees(response.data);
            showSnackbar('Hauliers fetched successfully', 'success');
        } catch (error) {
            const errorMessage =
                error.response?.statusText || error.message || 'Error fetching hauliers';
            showSnackbar(`Failed to fetch hauliers: ${errorMessage}`, 'error');
        }
    };
    const handleSendEmail = async (saleId) => {
        setSendingEmailId(saleId);

        try {
            await emailTechnicalRepairReplacementPdf(saleId, {});
            alert("Email sent successfully!");
        } catch (error) {
            console.error("Email error:", error);
            alert("Failed to send email.");
        }finally {
    setSendingEmailId(null);
  }
    };

    const handleStatusChange = async (saleId, newStatus, sale) => {
        const updatedSale = { ...sale, status: newStatus };

        try {
            await updateTechnicalRepairReplacement(saleId, updatedSale);

            // Update state in frontend
            setEmployees((prevData) =>
                prevData.map((item) =>
                    item.id === saleId ? { ...item, status: newStatus } : item
                )
            );

            showSnackbar('Status updated successfully', 'success');
        } catch (error) {
            console.error('Failed to update status:', error);
            showSnackbar('Failed to update status', 'error');
        }
    };
    const fetchHauliers = async () => {
        try {
            const response = await fetchCustomers();
            const allNames = response.data.map((employee) => employee.client_name);
            const haulierDict = response.data.reduce((acc, item) => {
                acc[item.id] = item.client_name;
                return acc;
            }, {});
            setHaulierOptions(haulierDict)
            setHauliers(allNames);
            showSnackbar('Hauliers fetched successfully', 'success');
        } catch (error) {
            const errorMessage =
                error.response?.statusText || error.message || 'Error fetching hauliers';
            showSnackbar(`Failed to fetch hauliers: ${errorMessage}`, 'error');
        }
    };

    const fetchDevices = async () => {
        try {
            const response = await fetchSolutions();
            const allNames = response.data.map((employee) => employee.name);
            const deviceDict = response.data.reduce((acc, item) => {
                acc[item.id] = item.name;
                return acc;
            }, {});
            setDevicesOptions(deviceDict)
            setDevice(allNames);
            showSnackbar('Hauliers fetched successfully', 'success');
        } catch (error) {
            const errorMessage =
                error.response?.statusText || error.message || 'Error fetching hauliers';
            showSnackbar(`Failed to fetch hauliers: ${errorMessage}`, 'error');
        }
    };

    const fetchTruck = async () => {
        try {
            const response = await fetchVehicles();
            const allNames = response.data.map((employee) => employee.name);
            const haulierDict = response.data.reduce((acc, item) => {
                acc[item.id] = item.registration_number;
                return acc;
            }, {});
            setTruckOptions(haulierDict)
            setTrucks(allNames);
            showSnackbar('Hauliers fetched successfully', 'success');
        } catch (error) {
            const errorMessage =
                error.response?.statusText || error.message || 'Error fetching hauliers';
            showSnackbar(`Failed to fetch hauliers: ${errorMessage}`, 'error');
        }
    };
    const [device, setDevice] = React.useState([])

    const [haulier, setHauliers] = React.useState([])
    const [trucks, setTrucks] = React.useState([])

    const [employees, setEmployees] = React.useState([])
    const [modalOpen, setModalOpen] = React.useState(false);
    // Save employees to localStorage on update
    React.useEffect(() => {
        // localStorage.setItem('employees', JSON.stringify(employees));
    }, [employees]);

    const handleOpen = () => setModalOpen(true);
    const handleClose = () => setModalOpen(false);


    const handleExport = () => {
  const doc = new jsPDF('l', 'mm', 'a2'); // Landscape A2

  // Title
  doc.setFontSize(18);
  doc.text('Technical Repair Replacement Report', 14, 16);

  // Columns (same as UI table, excluding Actions)
  const columns = [
    'Technical Log #',
    'Remarks',
    'IMEI',
    'Resource Name',
    'Location',
    'Installation Date',
    'Status',
  ];

  // Rows
  const tableData = employees.map((row) => [
    row.id,
    row.remarks || '',
    row.imei_details?.imei || '',
    usersOptions[row.resource_name] || '',
    row.location || '',
    formatDateForInput(row.installation_date),
    row.status || '',
  ]);

  // Generate table
  doc.autoTable({
    head: [columns],
    body: tableData,
    startY: 30,
    styles: {
      fontSize: 9,
      cellPadding: 2.5,
    },
    columnStyles: {
      0: { cellWidth: 35 }, // Technical Log #
      1: { cellWidth: 50 }, // Remarks
      2: { cellWidth: 40 }, // IMEI
      3: { cellWidth: 45 }, // Resource Name
      4: { cellWidth: 40 }, // Location
      5: { cellWidth: 50 }, // Installation Date
      6: { cellWidth: 35 }, // Status
    },
    theme: 'grid',
    didDrawPage: () => {
      doc.setFontSize(18);
      doc.text('Technical Repair Replacement Report', 14, 16);
    },
  });

  doc.save('Technical_Repair_Replacement_Report.pdf');
};

    function getBase64Image(imgPath) {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.src = imgPath; // Ensure this path points to your public folder image

            img.onload = () => {
                const canvas = document.createElement('canvas');
                const ctx = canvas.getContext('2d');
                canvas.width = img.width;
                canvas.height = img.height;
                ctx.drawImage(img, 0, 0);
                const dataUrl = canvas.toDataURL(); // This will give you the base64 string
                resolve(dataUrl); // Return the complete base64 string (including header)
            };

            img.onerror = reject;
        });
    }

    const EditOperationModal = ({
  open,
  handleClose,
  selectedRow,
}) => {
  const [imageFile, setImageFile] = React.useState(null);

  const schema = z.object({
    installation_date: z.string().min(1, "Required"),
    imei: z.string().min(1, "Required"),
    resource_name: z.string().min(1, "Required"),
    location: z.string().min(1, "Required"),
    remarks: z.string().optional(),
  });

  const defaultValues = {
    installation_date: formatDatetimeLocal(selectedRow?.installation_date) ?? "",
    imei: selectedRow?.imei_details?.imei ?? "",
    resource_name: String(selectedRow?.resource_name ?? ""),
    location: selectedRow?.location ?? "",
    remarks: selectedRow?.remarks ?? "",
  };

  return (
    <FormModal
      open={open}
      onClose={handleClose}
      title="Edit Installation Log"
      schema={schema}
      defaultValues={defaultValues}
      submitLabel="Update"
      width={400}
      onSubmit={async (data) => {
        const fd = new FormData();
        Object.entries(data).forEach(([k, v]) => {
          if (v !== null && v !== undefined && v !== "") fd.append(k, v);
        });
        if (imageFile) fd.append("image", imageFile);
        try {
          await updateTechnicalRepairReplacement(selectedRow.id, fd);
          showSnackbar("Updated successfully", "success");
          fetchDeliveries();
        } catch (err) {
          showSnackbar("Update failed", "error");
          throw err;
        }
      }}
    >
      {({ control }) => (
        <Grid container spacing={2.5}>
          <Grid item xs={12} md={6}>
            <RHFTextField control={control} name="installation_date" label="Installation Date" type="datetime-local" required />
          </Grid>
          <Grid item xs={12} md={6}>
            <RHFTextField control={control} name="imei" label="IMEI" required />
          </Grid>
          <Grid item xs={12} md={6}>
            <RHFSelect
              control={control}
              name="resource_name"
              label="Resource Name"
              required
              options={users.filter(u => u.department === "Monit").reduce((acc, u) => ({ ...acc, [u.id]: u.name || u.username }), {})}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <RHFTextField control={control} name="location" label="Location" required />
          </Grid>
          <Grid item xs={12}>
            <RHFTextField control={control} name="remarks" label="Remarks" multiline rows={3} />
          </Grid>
          <Grid item xs={12}>
            <Box sx={{ mt: 2 }}>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5, fontWeight: 500 }}>
                Image (optional)
              </Typography>
              <input
                type="file"
                accept="image/*"
                style={{ width: "100%" }}
                onChange={(e) => setImageFile(e.target.files?.[0] ?? null)}
              />
            </Box>
          </Grid>
        </Grid>
      )}
    </FormModal>
  );
};

    const formatDateForInput = (datetimeStr) => {
      if (!datetimeStr) return "";
      const date = new Date(datetimeStr);
      return date.toISOString().slice(0, 16);
    };
    return (
        <Container maxWidth="xl" sx={{ m: 2 }}>
            {editModalOn && selectedRow && (
                <EditOperationModal
                    selectedRow={selectedRow}
                    open={editModalOn}
                    handleClose={handleEditOff}
                />
            )}
            <DataTable
                title="Technical Repair/Replacement List"
                columns={[
                    { key: 'id', label: 'Technical Log #' },
                    { key: 'remarks', label: 'Remarks' },
                    { key: 'imei', label: 'IMEI', render: (row) => row.imei_details?.imei },
                    { key: 'resource_name', label: 'Resource Name', render: (row) => usersOptions[row.resource_name] },
                    { key: 'location', label: 'Location' },
                    { key: 'installation_date', label: 'Installation Date', render: (row) => formatDateForInput(row.installation_date) },
                ]}
                rows={employees}
                toolbarActions={<Button variant="contained" color="primary" style={{ marginLeft: "10px" }} onClick={handleExport}>Export to PDF</Button>}
                renderActions={(row) => (
                    <Box display="flex" gap="6px">
                        <IconButton color="secondary" size="small" onClick={() => handleEditOn(row)} sx={{ padding: '6px' }}><EditIcon /></IconButton>
                        <IconButton color="primary" size="small" onClick={() => handleSendEmail(row.id)} sx={{ padding: '6px', marginLeft: '4px' }} disabled={sendingEmailId === row.id}>
                            {sendingEmailId === row.id ? <CircularProgress size={20} color="inherit" /> : <SendIcon />}
                        </IconButton>
                        <Select value={row.status} onChange={(e) => handleStatusChange(row.id, e.target.value, row)} size="small" sx={{ ml: 1, minWidth: 100 }}>
                            <MenuItem value="Pending">Pending</MenuItem>
                            <MenuItem value="Complete">Complete</MenuItem>
                        </Select>
                    </Box>
                )}
            />
            <Snackbar
                open={snackbar.open}
                autoHideDuration={4000}
                onClose={handleSnackbarClose}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            >
                <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: '100%' }}>
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </Container>
    );
}
